import { FC, useEffect, useMemo, useRef, useState } from 'react'
import { fetchData, fetchFormData, formatDate, formatNumber, toasterrormsg, toastsuccessmsg } from '../../../reusable'
import { KTIcon } from '../../../_metronic/helpers'
import { ToastContainer } from 'react-toastify'
import DataTable from 'react-data-table-component'
import { Tr } from '../../../_metronic/i18n/Tr'
import StatusBadge from '../components/StatusBadge'
import { Modal } from 'react-bootstrap'
import { FileUploader } from 'react-drag-drop-files'

interface ReferralData {
  proof?: string;
  referralhistoryId?: string;
  cardNumber?: string;
  cardUserName?: string;
  age?: string;
  mobileNumber?: string;
  regionName?: string;
  email?: string;
  gender?: string;
  fullName?: string;
  userAddress?: string;
}


const ViewReferrals: FC = () => {
  let t = Tr()
  const [referralList, setReferralList] = useState([])
  const [loading, setLoading] = useState(false)
  const [searchTerm, setSearchTerm] = useState('')
  const [focus, setFocus] = useState('')
  const [limit, setLimit] = useState(10)
  const [offset, setOffset] = useState(0)
  const [totalRecords, setTotalRecords] = useState('') as any
  const [sortColumn, setSortColumn] = useState('')
  const [sortDirection, setSortDirection] = useState<'asc' | 'desc'>('desc')
  const [apiTerm, setApiTerm] = useState('')
  const [totalAccepted, setTotalAccepted] = useState('')
  const [totalAmount, setTotalAmount] = useState('')
  const [showPaymentStatus, setShowPaymentStatus] = useState(false)
  const [paymentData, setPaymentData] = useState<ReferralData>({});
  const [detailType, setDetailType] = useState("")
  const [selectedImage, setSelectedImage] = useState(undefined) as any
  const [selectedFromDate, setSelectedFromDate] = useState("") as any
  const [selectedToDate, setSelectedToDate] = useState("") as any
  const [error, setError] = useState(Object)
  const fileTypes = ['JPEG', 'JPG', 'PNG']

  var tmp2 = sessionStorage.getItem('admin')
  if (tmp2) {
    var adminData = JSON.parse(tmp2)
    var adminId = adminData.adminId
  }

  const clearFields = () => {
    setSelectedFromDate('')
    setSelectedToDate('')

  }


  const handleShowPaymentStatus = () => setShowPaymentStatus(true)
  const handleClosePaymentStatus = () => {
    setPaymentData({})
    setShowPaymentStatus(false)
    setSelectedImage(undefined)
  }


  //   referral and review list api call
  const referralListApiCall = async () => {
    var param: any = {
      limit: limit,
      offset: offset,
      search: apiTerm,
      sort: sortDirection,
      sortBy: sortColumn,
      fromDate: selectedFromDate,
      toDate: selectedToDate,

    }

    var res = await fetchData('admin/viewreferral ', param)

    if (res.status == '200') {  
      var data = res.data
      
      setReferralList(data.data || [])
      setTotalRecords(data.totalRecords || 0)
      setTotalAccepted(data.totalAccepted || 0)
      setTotalAmount(data.totalAmount || 0)
    } else {
      toasterrormsg(res.message)
    }
  }


  const searchData = async (text: any, isfoc: any) => {
    setSearchTerm(text)
    setFocus(isfoc)

    const escapedTerm = text.replace(/'/g, "''")
    setApiTerm(escapedTerm)
  }

  const handleSort = (column: any, sortDirection: 'asc' | 'desc') => {
    setSortColumn(column.sortField)
    setSortDirection(sortDirection)
  }
  const CustomHeader = (props: any) => {
    const inputRef: any = useRef(null)

    // Define the onchange event handler
    const handleChange = async (e: any) => {
      // Focus on the input element when the onchange event is triggered
      await props.fnserch(e, 1)
      // inputRef.current.focus();
    }
    useEffect(() => {
      // Check if the ref exists and if the component should be focused
      if (inputRef.current && props.isfoc === 1) {
        inputRef.current.focus()
      }
    }, [props.isfoc])

    return (
      <div className='d-flex justify-content-between flex-wrap w-100 my-5'>
        <div className='d-flex align-items-center position-relative my-1 '>
          <KTIcon iconName='magnifier' className='fs-1 position-absolute ms-6' />
          <input
            type='text'
            data-kt-user-table-filter='search'
            className='form-control form-control-solid w-250px ps-14'
            placeholder={t('Search Referrals')}
            value={props.search}
            onChange={(e: any) => handleChange(e.target.value)}
            ref={inputRef}
          />
        </div>

      </div>
    )
  }

  // remove validation function
  const removeError = (err: any) => {
    // Ensure error is an array before spreading
    var tmp = Array.isArray(error) ? [...error] : [{}]

    // Ensure the first object exists
    if (!tmp[0]) tmp[0] = {}

    tmp[0][err] = '' // Clear the specific error key
    setError(tmp)
  }

  // handle image change function
  const handleProofChange = (file: any) => {
    if (file) {
      if (!file.type.startsWith('image/')) {
        // Invalid file type
        // Handle error or display a message
        toasterrormsg('Invalid file type. Please upload only image.')
        setSelectedImage(undefined)

        return
      }
      // Handle business registration file change
      // For example:
      setSelectedImage(file)
      removeError('businessRegistration')
    } else {
    }
  }

  // validate proof upload
  const validateProofUpload = () => {
    var isValid = true

    var errorTmp = Array.isArray(error) ? [...error] : [{}] // Ensure it's an array
    if (selectedImage == '' || selectedImage == null || selectedImage == undefined) {
      errorTmp[0].selectedImage = t('Proof Image Is Required')
      isValid = false
    }

    setError(errorTmp)

    if (isValid) {
      saveUploadProof()
    }
  }


  const saveUploadProof = async () => {
    setLoading(true)
    let param: any = new FormData()

    param.append("proof", selectedImage);
    param.append("adminId", adminId);
    param.append("referralhistoryId", paymentData?.referralhistoryId);

    var res = await fetchFormData('admin/markaspaid', param)

    if (res.status == '200') {
      setLoading(false)
      handleClosePaymentStatus()
      referralListApiCall()
      toastsuccessmsg(res.message)
    } else {
      setLoading(false)
      toasterrormsg(res.message)
    }
  }

  // Define your DataTable columns
  const column = useMemo(
    () => [
      {
        name: t('Referral Code'),
        cell: (row: any) => {
          const isValidReferral =
            row.referralCode &&
            row.referralCode !== '' &&
            !row.referralCode.includes('Total')

          return (
            <div className="my-3">
              <div
                className={`fw-bold fs-5 ${isValidReferral ? 'text-primary text-decoration-underline' : ''
                  }`}
                {...(isValidReferral
                  ? {
                    onClick: () => {
                      handleShowPaymentStatus()
                      setPaymentData(row)
                      setDetailType('viewAmbassadors')
                    },
                    style: { cursor: 'pointer' }, // makes it clear it's clickable
                  }
                  : {})}
              >
                {row.referralCode && row.referralCode !== ''
                  ? row.referralCode.includes('Total')
                    ? row.referralCode
                    : `#${row.referralCode}`
                  : '-'}
              </div>
            </div>
          )
        },

        sortField: 'referralCode',
        sortable: true,
        width: '150px',
      },
      {
        name: t('Date Submitted'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>{row.submitDate && row.submitDate != "" ? formatDate(row.submitDate, "MM-DD-YYYY") : "-"}</div>
          </div>
        ),
        sortable: true,
        width: '200px',
        sortField: 'submitDate',
      },
      {
        name: t('Date Verification'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>{row.verifiedDate && row.verifiedDate != "" ? formatDate(row.verifiedDate, "MM-DD-YYYY") : "-"}</div>
          </div>
        ),
        sortable: true,
        width: '200px',
        sortField: 'verifiedDate',
      },
      {
        name: t('Property Verification'),
        cell: (row: any) => {
          const status = String(row.propertyStatus ?? ""); // always string
          return (
            <div className='my-3'>
              <div className={` ${status.includes("Accepted") ? "px-3" :""} fw-bold fs-5`}>
                {status.includes("Accepted") ? (
                  status
                ) : (
                  <StatusBadge
                    status={status}
                    label={
                      status === "0"
                        ? t("Pending")
                        : status === "1"
                          ? t("Approved")
                          : status === "2"
                            ? t("Rejected")
                            : ""
                    }
                    className={
                      status === "0"
                        ? "btn-warning"
                        : status === "1"
                          ? "btn-success"
                          : status === "2"
                            ? "btn-danger"
                            : ""
                    }
                  />
                )}
              </div>
            </div>
          );
        },
        sortable: true,
        width: '200px',
        sortField: 'propertyStatus',
      },

      {
        name: t('Property Name'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>{row.propertyName && row.propertyName != "" ? row.propertyName : "-"}</div>
          </div>
        ),
        sortable: true,
        width: '200px',
        sortField: 'propertyName',
      },
      {
        name: t('Service Type'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>{row.categoryName && row.categoryName != "" ? row.categoryName : "-"}</div>
          </div>
        ),
        sortable: true,
        width: '200px',
        sortField: 'categoryName',
      },
      {
        name: t('Property Type'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>{row.propertyType && row.propertyType != "" ? row.propertyType : "-"}</div>
          </div>
        ),
        sortable: true,
        width: '200px',
        sortField: 'propertyType',
      },
      {
        name: t('Property Location'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>{row.location && row.location != "" ? row.location : "-"}</div>
          </div>
        ),
        sortable: true,
        width: '200px',
        sortField: 'location',
      },
      {
        name: t('Expenses'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>{row.amount && row.amount != "" ? formatNumber(row.amount) : "-"}</div>
          </div>
        ),
        sortable: true,
        width: '200px',
        sortField: 'amount',
      },
      {
        name: t('Card Details'),
        cell: (row: any) => (
          <div className="my-3">
            {/* Card Number */}
            <div className="fw-bold fs-5">
              {row.cardNumber && row.cardNumber !== "" ? row.cardNumber : "-"}
            </div>

            {/* Card Holder Name */}
            <div className="text-muted">
              {row.cardUserName && row.cardUserName !== "" ? row.cardUserName : "-"}
            </div>
          </div>
        ),
        sortable: false,
        width: "250px",
        sortField: "cardNumber",
      },
      {
        name: t('Payment Status'),
        cell: (row: any) => {
          const status = String(row.paymentStatus ?? '')
          return (
            <div className='my-3 d-flex align-items-center gap-2'>
              {status === '1' && (
                <>
                  <span className='badge badge-light-success fs-7 fw-bold px-4 py-2'>
                    <KTIcon iconName='check-circle' className='fs-5 text-success me-1' />
                    {t('Paid')}
                  </span>
                  {row.proof && (
                    <button
                      type='button'
                      className='btn btn-icon btn-sm btn-light-primary'
                      title={t('View Proof')}
                      onClick={() => {
                        handleShowPaymentStatus()
                        setPaymentData(row)
                        setDetailType('imageProof')
                      }}
                    >
                      <KTIcon iconName='eye' className='fs-3' />
                    </button>
                  )}
                </>
              )}

              {status === '0' && (
                <button
                  type='button'
                  className='btn btn-sm btn-primary fw-bold'
                  onClick={() => {
                    handleShowPaymentStatus()
                    setPaymentData(row)
                    setDetailType('uploadImage')
                  }}
                >
                  <KTIcon iconName='wallet' className='fs-4 me-1' />
                  {t('Mark As Paid')}
                </button>
              )}
            </div>
          )
        },
        sortable: true,
        width: '200px',
        sortField: 'paymentStatus',
      },
      {
        name: t('Payment Date'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>{row.paymentDate && row.paymentDate != "" ? formatDate(row.paymentDate, "MM-DD-YYYY") : "-"}</div>
          </div>
        ),
        sortable: true,
        width: '200px',
        sortField: 'paymentDate',
      },
      {
        name: t('Note'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>{row.note && row.note != "" ? row.note : "-"}</div>
          </div>
        ),
        sortable: true,
        width: '200px',
        sortField: 'note',
      },


    ],
    [t]
  )
  useEffect(() => {
    referralListApiCall()
    document.title = 'Insayr | View Review Category Wise'
  }, [limit, offset, sortColumn, sortDirection, searchTerm]) // Trigger on pagination changes


  const customRow = {
    referralCode: "Total" + " " + totalRecords, // Unique identifier to differentiate it
    submitDate: '',
    verifiedDate: '',
    propertyStatus: `${totalAccepted} Accepted`,  // always a string
    propertyName: '',
    categoryName: "",
    categoryName2: '',
    location: '',
    amount: totalAmount,
    amount2: '',
    paymentStatus: "",
    paymentDate: '',
    note: '',
  }

  
  // Combine hotelList with the custom row for display
  const dataWithCustomRow = useMemo(() => {
    // Always append the custom row to the current page's data
    return [...referralList, customRow]
  }, [referralList])


  const handlePageChange = (newPage: number) => {
    const totalPages = Math.ceil(totalRecords / limit)
    if (newPage === 1) {
      setOffset(0)
    } else if (newPage === totalPages) {
      setOffset((totalPages - 1) * limit)
    } else {
      setOffset((newPage - 1) * limit)
    }
  }

  const handleRowsPerPageChange = (newRowsPerPage: number, currentPage: number) => {
    setLimit(newRowsPerPage)
  }

  return (
    <>
      <ToastContainer />
      <div className='container'>
        <div className='justify-content-center d-flex flex-wrap gap-5 mb-6'>
          <div className='filters'>
            <label htmlFor='fromDate' className='fs-4 form-label'>
              {t('From Date')}
            </label>
            <input
              type='date'
              name='fromDate'
              className='form-control'
              placeholder={t('From Date')}
              value={selectedFromDate}
              onChange={(e) => setSelectedFromDate(e.target.value)}
            />
          </div>
          <div className='filters'>
            <label htmlFor='toDate' className='fs-4 form-label'>
              {t('To Date')}
            </label>
            <input
              type='date'
              name='toDate'
              className='form-control'
              placeholder={t('To Date')}
              value={selectedToDate}
              onChange={(e) => setSelectedToDate(e.target.value)}
            />
          </div>
        </div>
      </div>
       <div className='d-flex justify-content-center mb-5'>
        <div className='col-md-2 mb-3 d-flex align-items-end'>
          <button
            className='btn btn-primary mx-1'
            onClick={() => referralListApiCall()}
          >
            {t('Apply')}
          </button>
          <button className='btn btn-danger mx-1' onClick={() => clearFields()}>
            {t('Clear')}
          </button>
        </div>
      </div>
      <DataTable
        columns={column}
        data={dataWithCustomRow}
        pagination
        paginationServer={true}
        onChangePage={handlePageChange}
        paginationTotalRows={totalRecords}
        paginationPerPage={limit}
        onChangeRowsPerPage={handleRowsPerPageChange}
        paginationRowsPerPageOptions={[5, 10, 15, 20, 25, 30]}
        subHeader={true}
        subHeaderComponent={<CustomHeader search={searchTerm} isfoc={focus} fnserch={searchData} />}
        onSort={handleSort}
        paginationComponentOptions={{
          rowsPerPageText: t('Rows Per Page'),
        }}
        sortServer
      />

      <Modal show={showPaymentStatus} onHide={handleClosePaymentStatus} backdrop='static' keyboard={false}>
        <div
          className='modal fade show'
          tabIndex={-1}
          style={{ display: 'block' }}
          aria-modal='true'
          role='dialog'
        >
          <div className='modal-dialog modal-dialog-centered mw-700px'>
            <div className='modal-content'>
              <div className='form'>
                <div className='modal-header d-flex justify-content-between border-bottom border-1 border-success'>
                  <h2 className='fw-bold'>
                    <i className="ki-duotone ki-flag fs-2 me-2 text-danger"></i>
                    {t('Payment Details')}
                  </h2>
                  <div
                    className='btn btn-icon btn-sm btn-active-icon-primary'
                    onClick={handleClosePaymentStatus}
                  >
                    <i className='ki-duotone ki-cross fs-1'>
                      <span className='path1'></span>
                      <span className='path2'></span>
                    </i>
                  </div>
                </div>

                <div className="modal-body pt-10 pb-15 px-lg-17 text-center">
                  {detailType === "imageProof" && (
                    <>
                      <td className='fw-bold fs-3'>Proof Image</td>

                      <div
                        style={{
                          maxWidth: "100%",
                          maxHeight: "80vh", // prevent overflow outside modal
                          overflow: "hidden",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <img
                          src={paymentData.proof}
                          alt="Payment Proof Image"
                          style={{
                            maxWidth: "100%",
                            maxHeight: "100%",
                            objectFit: "contain",
                            borderRadius: "8px",
                          }}
                        />
                      </div>
                    </>
                  )}
                  {detailType === "uploadImage" && (
                    <>
                      <td className='fw-bold fs-4 required '>Upload Proof</td>

                      <FileUploader
                        multiple={false}
                        handleChange={handleProofChange}
                        name='businessIDProof'
                        types={fileTypes}
                        classes='w-100 mt-3'
                      >
                        <div
                          className='dropzone border-success bg-light-success dz-clickable'
                          id='kt_ecommerce_add_business_certificate'
                        >
                          <div className='dz-message needsclick'>
                            {/* <!--begin::Icon--> */}
                            <i className='ki-outline ki-file-up text-success fs-3x'></i>
                            {/* <!--end::Icon--> */}
                            {/* <!--begin::Info--> */}
                            <div className='ms-4'>
                              <h3 className='fs-5 fw-bold text-gray-900 mb-1'>
                                {t("Upload Proof")}
                              </h3>
                              <span className='fs-7 fw-semibold text-gray-500'>
                                {t("Drag & Drop or choose files from computer")}
                              </span>
                            </div>
                            {/* <!--end::Info--> */}
                          </div>
                        </div>
                      </FileUploader>
                      <div className="text-start mt-2">
                        <label className="text-danger">
                          {error && error[0] && error[0].selectedImage ? error[0].selectedImage : ""}
                        </label>
                      </div>

                      {selectedImage != undefined && selectedImage != "" ?

                        <div
                          style={{
                            maxWidth: "100%",
                            maxHeight: "80vh", // prevent overflow outside modal
                            overflow: "hidden",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <img
                            src={URL.createObjectURL(selectedImage)}
                            alt="Payment Proof Image"
                            style={{
                              maxWidth: "100%",
                              maxHeight: "100%",
                              objectFit: "contain",
                              borderRadius: "8px",
                            }}
                          />
                        </div>
                        : ""}



                      <div className='d-flex justify-content-end mt-5'>
                        <button
                          type='button'
                          disabled={loading}
                          className='btn btn-success'
                          onClick={validateProofUpload}
                        >
                          <span className='indicator-label'>{t("Save")}</span>
                          {loading && (
                            <span
                              className='spinner-border spinner-border-sm mx-2'
                              role='status'
                              aria-hidden='true'
                            ></span>
                          )}
                        </button>
                        {/* <!--end::Button--> */}
                      </div>

                    </>
                  )}
                  {detailType === "viewAmbassadors" && paymentData && (
                    <div className=" text-start">
                      <p><strong>Ambassador:</strong> {paymentData.fullName || "-"}</p>
                      <p><strong>Age:</strong> {paymentData.age ? `${paymentData.age} yrs` : "-"}</p>
                      <p><strong>Gender:</strong> {paymentData.gender || "-"}</p>
                      <p><strong>Region:</strong> {paymentData.regionName || "-"}</p>
                      <p><strong>Town/District/City:</strong> {paymentData.userAddress}</p>
                      <p><strong>Phone Number:</strong> {paymentData.mobileNumber || "-"}</p>
                      <p><strong>Email:</strong> {paymentData.email || "-"}</p>

                      <details className="mt-2">
                        <summary><strong>Card Details:</strong></summary>
                        <div className="ms-4 mt-2">
                          <p><strong>Name:</strong> {paymentData.cardUserName || "-"}</p>
                          <p><strong>Card number:</strong> {paymentData.cardNumber || "-"}</p>
                        </div>
                      </details>
                    </div>
                  )}

                </div>

              </div>
            </div>
          </div>
        </div>
      </Modal>

    </>
  )
}

export { ViewReferrals }
